import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "set-filter" }, "Нажмите кнопку отфильтровать!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logs_view_filter = _resolveComponent("logs-view-filter")!
  const _component_hardware_logs_view = _resolveComponent("hardware-logs-view")!
  const _component_bs_col = _resolveComponent("bs-col")!
  const _component_bs_row = _resolveComponent("bs-row")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, { name: "Мониторинг ресурсов компьютера" }, {
    default: _withCtx((slotProps) => [
      _createVNode(_component_logs_view_filter, {
        filter: _ctx.filterModel,
        "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterModel) = $event)),
        logsType: false,
        logsLevel: false,
        hardwareLogsType: true,
        addPanel: false
      }, null, 8, ["filter"]),
      _createVNode(_component_hardware_logs_view, { filter: _ctx.filterModelView }, null, 8, ["filter"]),
      (!_ctx.filterModelView)
        ? (_openBlock(), _createBlock(_component_bs_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_bs_col, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}